import { MessageCircle, Phone } from "lucide-react";
import Logo from "@/components/Logo";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_NUMBER } from "@/constants/brand";

export default function Footer() {
  const waUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hi! I'd like to order a Jain Special Thali on my train journey.")}`;
  return (
    <footer id="contact" className="bg-emerald-950 pt-24" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid gap-12 pb-16 lg:grid-cols-[1.2fr_0.8fr] lg:items-end">
          <div>
            <p className="mb-3 text-xs font-bold uppercase tracking-[0.24em] text-amber-400">Talk to us</p>
            <h2 className="font-display text-4xl font-bold leading-tight tracking-tight text-amber-50 sm:text-6xl" data-testid="footer-heading">
              Hungry on the move? <span className="italic text-amber-400">One call away.</span>
            </h2>
            <div className="mt-8 flex flex-wrap gap-4">
              <a
                href={PHONE_TEL}
                data-testid="footer-call-button"
                className="inline-flex items-center gap-2 rounded-full bg-amber-500 px-7 py-3.5 text-base font-bold text-emerald-950 transition-colors hover:bg-amber-400"
              >
                <Phone className="h-5 w-5" /> Call {PHONE_DISPLAY}
              </a>
              <a
                href={waUrl}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-whatsapp-button"
                className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-7 py-3.5 text-base font-bold text-white transition-colors hover:bg-[#1eb856]"
              >
                <MessageCircle className="h-5 w-5" /> WhatsApp Us
              </a>
            </div>
          </div>
          <div className="lg:text-right">
            <Logo onDark />
            <p className="mt-4 text-sm leading-relaxed text-amber-100/60">
              Pure satvik Jain food, cooked fresh and delivered to your train seat across major
              junctions in Bihar, UP and beyond.
            </p>
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-3 border-t border-amber-100/10 py-6 text-xs text-amber-100/50">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} Jain Food on Train. All rights reserved.</p>
          <a href="/admin/login" data-testid="footer-admin-link" className="font-semibold transition-colors hover:text-amber-300">
            Admin Login
          </a>
        </div>
      </div>
    </footer>
  );
}
